import * as angular from "angular";
import {BringozApi} from "../persistence-layer/models/bringoz-api.model";
import {DataStoreConfig} from "../persistence-layer/models/datastore-config.model";
import {BringozObject} from "../persistence-layer/bringoz-object";
import {Rule} from "./models/rule.model";
import {$bringozFactory} from "../persistence-layer/bringoz-factory.factory";

angular
  .module('bringoz.admin.ruleEngine')
  .factory('$rule', ruleObjectFactory);

export type $ruleFactory = (id: string) => BringozObject<Rule>;

function ruleObjectFactory($bringozFactory: $bringozFactory,
                           rulesAPI: BringozApi,
                           Rules_DS: DataStoreConfig) {

  function $rule(id: string) {
    return $bringozFactory(id, rulesAPI, Rules_DS)
  }

  return $rule;

}
